import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from 'src/app/common/services/api.service';
import { MessageService } from 'src/app/common/services/message.service';
import { WebSocketService } from 'src/app/web-socket.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { country } from '../common/enums/language';
import { LanguageService } from '../common/services/language.service';
import { Router } from '@angular/router';
import { LocalStorageService } from '../common/services/localStorage.service';
import { DateService } from '../common/services/date.service';
import { membership } from '../common/enums/membership.enum';
import { EasyEatHqService } from '../common/services/ee-hq.service';
import {
  PineLabDefaultChannel,
  PineLabsConsts,
  PineLabsEnum,
} from '../common/enums/pinelabs.enum';
import { EventTrackerService } from '../common/services/event-tracker.service';
import {
  PAYMENT_CHANNEL_ID,
  PAYMENT_GATEWAY,
  PAYMENT_PROCESS,
  PaymentMethod,
} from '../common/enums/payment';
import { CashierActionType } from '../invoice/models/enums/invoice.enum';
import { OnlinePaymentParamsInterface } from './interface/util.interface';
declare function send_data(params: string): any;

let orderType = [
  {
    id: 0,
    name: 'Dine In',
    img: 'dining_room.svg',
    img_src: '',
    platform: 'easyeat',
    order_type: 0,
    email: null,
  },
  {
    id: 2,
    name: 'Takeaway',
    img: 'lunch.svg',
    img_src: '',
    platform: 'easyeat',
    order_type: 2,
    email: null,
  },
];

@Injectable({
  providedIn: 'root',
})
export class UtilService implements OnInit, OnDestroy {
  interval;
  lastActiveIntervalInterval;
  translationText;
  subscription = new Subscription();
  rest_settings;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private messageService: MessageService,
    private webSocket: WebSocketService,
    private translateService: TranslateService,
    private languageService: LanguageService,
    private _localStorage: LocalStorageService,
    private _hqService: EasyEatHqService,
    private _eventTracker: EventTrackerService,
    private _dateService: DateService
  ) {
    this.rest_settings = this._localStorage.get('restaurant_settings');
  }
  ngOnInit(): void {
    this.subscription.add(
      this.translateService.get(['UTIL']).subscribe((res) => {
        this.translationText = res.UTIL;
      })
    );
  }

  ngOnDestroy(): void {
    this.stopPolling();
    clearInterval(this.lastActiveIntervalInterval);
    this.subscription.unsubscribe();
  }
  filterPaymentMethod(paymentMethod, platform) {
    let filtered_paymentMethod = (paymentMethod || []).filter((x) => {
      if (
        platform == 'easyeat' &&
        (x.channel == 'offline_fpanda_settle' ||
          x.channel == 'offline_grab_settle')
      ) {
        return false;
      } else if (
        platform == 'foodpanda' &&
        x.channel == 'offline_grab_settle'
      ) {
        return false;
      } else if (platform == 'grab' && x.channel == 'offline_fpanda_settle') {
        return false;
      } else {
        return true;
      }
    });

    return filtered_paymentMethod;
  }

  /**
   * Pine Labs card should be shown but non-interactive when gateway is pinelabs / pine_labs.
   */
  isPineLabsPaymentCardUiDisabled(item: any): boolean {
    if (!item || item.id !== PaymentMethod.PINE_LABS) {
      return false;
    }
    const gw = (item.payment_gateway ?? '').toString().trim().toLowerCase();
    if (!gw) {
      return false;
    }
    const n = gw.replace(/-/g, '_');
    return n === 'pine_labs' || n === 'pinelabs';
  }

  /** API `health`: 1 = available, 0 = temporarily unavailable */
  isPaymentMethodHealthDisabled(item: any): boolean {
    return item != null && item.health === 0;
  }
  prepareOrderTypeList(data) {
    let list = [...orderType];
    if (data && data.length) {
      data.forEach((item) => {
        list.push({
          id: item.order_type,
          name: item.name,
          img: item.img,
          img_src: '',
          platform: item.id,
          order_type: item.order_type,
          email: item.email ? item.email : null,
        });
      });
      return list;
    } else return list;
  }
  /**
   * Partner method responses keep OFFLINE-POS in the first group and terminal in its own group.
   * The POS screens render the first group, so the terminal cards are appended there.
   */
  mergeTerminalPaymentGroup(groups: any): any {
    const list = Array.isArray(groups) ? groups : [];
    const first = list[0] || { data: [] };
    const terminal = list.find((group) => group?.type === 'terminal');
    if (!terminal || terminal === first) {
      return first;
    }
    const extra = Array.isArray(terminal.data) ? terminal.data : [];
    return {
      ...first,
      data: [...(Array.isArray(first.data) ? first.data : []), ...extra],
    };
  }

  parsePaymentMethod(paymentMethods, platform) {
    let payMethods = paymentMethods.data;
    let list = [];
    if (payMethods && payMethods.length) {
      payMethods.forEach((paymentMethod) => {
        list.push({
          id: paymentMethod.config_id,
          name: paymentMethod.name,
          img: paymentMethod.icon,
          img_src: paymentMethod.icon,
          type: paymentMethod.method_type,
          channel: paymentMethod.data.channel_id,
          health: paymentMethod.health,
          payment_gateway:
            paymentMethod.payment_gateway ??
            paymentMethod.data?.payment_gateway ??
            (paymentMethod.config_id === PaymentMethod.PINE_LABS
              ? PineLabsEnum.PAYMENT_GATEWAY
              : undefined),
        });
      });
    }
    // list = this.filterPaymentMethod(list, platform);

    return list;
  }

  getPaymentMethod(paymentObjArray: any, fees?) {
    let voucherText = '';
    fees &&
      fees.forEach((x) => {
        if (x.type && x.type === 'voucher') {
          voucherText += (voucherText && ' + ') + `${x.fee_name} (${x.code})`;
        }
      });

    let paymentMethod = '';
    let returnPM = '';
    if ((paymentObjArray || []).length === 0 && !voucherText) {
      return 'NIL';
    } else if ((paymentObjArray || []).length === 0 && voucherText) {
      return voucherText;
    } else {
      (paymentObjArray || []).forEach((x, i) => {
        // if(paymentObjArray.length === 1){
        //   paymentMethod = x.payment_method
        // }else{
        paymentMethod =
          (x.payment_method || x.payment_channel) + `(${x.amount})`;
        // }
        returnPM +=
          paymentMethod + (i === paymentObjArray.length - 1 ? '' : ' + ');
      });
    }
    return returnPM + `${voucherText && ' + ' + voucherText}`;
  }

  get_pos_order_type(orderType) {
    let options = orderType.filter((x) => {
      x.img_src =
        environment.aws_s3_bucket_url + '/partner-app/order_type/' + x.img;
      return true;
    });
    return options;
  }

  getPosMenuAvailabilityMask(orderTypeId: number | string, platform?: string): number {
    const id = Number(orderTypeId);
    const plat = (platform || localStorage.getItem('pos_platform') || '').toLowerCase();
    const platformOt = Number(localStorage.getItem('pos_platform_order_type'));
    const isDualOfflinePlatform =
      !!plat &&
      plat !== 'easyeat' &&
      (plat === 'foodpanda' || id === 3 || platformOt === 3);

    if (isDualOfflinePlatform) {
      return 6;
    }
    if (id === 0) return 1;
    if (id === 1) return 2;
    if (id === 2) return 4;
    return 1;
  }

  getOpenItemIamgePath() {
    return environment.aws_s3_bucket_url + '/partner-app/assets/open_item.svg';
  }

  getStaffCount(data) {
    let staffData;
    staffData = data.filter((staff) => staff.user_type !== 'MM');
    return staffData.length;
  }

  getTableCount(data) {
    let count = 0;
    data.forEach((floor) => (count += floor.tables.length));
    return count;
  }

  getKitchenCounterCount(data) {
    let count = 0;
    data.forEach((item) => (item.status === '1' ? count++ : ''));
    return count;
  }

  getSectionCount(data) {
    return data.length;
  }

  generateRandomString(len) {
    let characters =
      '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let charactersLength = characters.length;
    let randomString = '';
    for (let i = 0; i < len; i++) {
      randomString += characters[Math.floor(Math.random() * charactersLength)];
    }
    return randomString;
  }

  generateRandomNumber(len) {
    let characters = '0123456789';
    let charactersLength = characters.length;
    let randomString = '';
    for (let i = 0; i < len; i++) {
      randomString += characters[Math.floor(Math.random() * charactersLength)];
    }
    return randomString;
  }

  clearCartData() {
    this._localStorage.set('pos_order_type', '0');
    this._localStorage.set('pos_platform', 'easyeat');
    localStorage.setItem('pos_username', '');
    localStorage.setItem(
      'pos_dial_code',
      localStorage.getItem('pos_dial_code')
    );
    localStorage.setItem('pos_number', '');
    localStorage.setItem('user_dob', '');
    localStorage.setItem('user_gender', '');
    localStorage.setItem('pos_user_id', '');
    localStorage.setItem('pos_table_no', 'dl');
    localStorage.setItem('pos_table_id', 'dl');
    localStorage.setItem('pos_order_id', '');
    localStorage.setItem('pos_no_enter', '0');
  }

  clearUserInformation() {
    localStorage.setItem('pos_username', '');
    localStorage.setItem('pos_number', '');
    localStorage.setItem('user_gender', '');
    localStorage.setItem('user_dob', '');
    localStorage.setItem('pos_no_enter', '0');
  }

  // on accept order , type = 4
  sendPrintCommand(order_id, itr) {
    itr = parseInt(itr);
    let data = {
      order_id: order_id,
      type: 4,
      counter_id: '',
      itr: itr,
    };

    if (this.isReactDevice() && this.isPrintOnAccept()) {
      this.send_data_to_react(
        this.getDataWithDeviceIdIfMultiCashDrawerEnable(data)
      );
    } else if (this.isPrintOnAccept()) {
      // appending token and new_format for windows event
      data = this.appendWindowsPrintPayload(data, 'non_cash_management');
      this.openReceiptWindow(data);
    }
  }

  sendPrintOnPaidPosCommand(order_id) {
    let data = {
      order_id: order_id,
      type: 8,
      counter_id: '',
      itr: 1,
    };

    if (this.isReactDevice() && this.isPrintOnAccept()) {
      this.send_data_to_react(
        this.getDataWithDeviceIdIfMultiCashDrawerEnable(data)
      );
    } else if (this.isPrintOnAccept()) {
      // appending token and new_format for windows event
      data = this.appendWindowsPrintPayload(data, 'non_cash_management');
      this.openReceiptWindow(data);
    }
  }

  sendFinalPrintCommand(order_id, is_dkick?) {
    let data = {
      order_id: order_id,
      type: 1,
      counter_id: '',
      itr: 1,
    };
    if (is_dkick) data['action'] = 'dkick_type1';
    if (this.isReactDevice() && this.isPrinterEnabled()) {
      this.send_data_to_react(
        this.getDataWithDeviceIdIfMultiCashDrawerEnable(data)
      );
    } else if (this.isPrinterEnabled()) {
      // appending token and new_format for windows event
      data = this.appendWindowsPrintPayload(data, 'non_cash_management');
      this.openReceiptWindow(data);
    }
  }

  sendDynamicQrPrintCommand(printQrObj){
    let data = {
      restaurant_id: this._localStorage.get('restaurant_id'),
      expiry_time: this._dateService.getCurrentEpoch() + printQrObj?.expiryTime,
      table_id: printQrObj?.tableId,
      table_no: printQrObj?.tableNo,
      action: "dynamicQR",
      new_format:1,
      type:11,
      device_id:'',
      qrsize: this.getRestaurantSettings()?.global?.qr_ordering_size ?? 550
    }
    if(this.isReactDevice() && this.isPrinterEnabled()){
      this.send_data_to_react(this.getDataWithDeviceIdIfMultiCashDrawerEnable(data),'dynamic-qr');
    }else if (this.isPrinterEnabled()) {
      // appending token and new_format for windows event
      data = this.appendWindowsPrintPayload(data, 'non_cash_management');
      this.openReceiptWindow(data);
    }
  }

  openCashDrawer() {
    let dkick_code = '';
    try {
      dkick_code = JSON.parse(localStorage.getItem('dkick_code'));
    } catch (error) {}
    let printer = localStorage.getItem('restaurant_printer');
    let data = {
      printerName: printer,
      numCode: dkick_code,
    };
    if (
      dkick_code !== '' &&
      dkick_code !== undefined &&
      printer !== '' &&
      printer !== undefined &&
      !this.isReactDevice()
    ) {
      // appending token and new_format for windows event
      data = this.appendWindowsPrintPayload(data, 'cash_management');
      this.openCashDrawerWindow(data);
    } else {
      console.log('cash drawer cannot be opened');
    }
  }

  // open new window for cashdrawer
  openCashDrawerWindow(data, timeout = null) {
    let x = JSON.stringify(data);
    if (timeout === null) {
      timeout = this.getCashDrawerWindowTime();
    }
    let finalData = 'cashdrawer:' + encodeURI(x);
    let cd_win = window.open(
      finalData,
      'cdwindow',
      'width=1,height=1,left=6,top=4,location=0'
    );
    if (!cd_win) {
      this.messageService.showError(
        'Cash drawer window is being blocked! Please allow it from setting'
      );
    }
    setTimeout(function () {
      try {
        cd_win.close();
      } catch (error) {}
    }, timeout);
  }
  openCashDrawerPrintReceipt(data, type) {
    let typeObj = {
      'cash-in': 1,
      'cash-out': 2,
      'drawer-kick': 4,
      'open-cashier': 8,
      'close-cashier': 16,
    };
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      let delay = restSettings.print.print_delay || 1000;
      let action = restSettings.print.cash_drawer || 0;
      let timeout = this.getCashDrawerWindowTime();
      if (typeObj[type] & action && !this.isReactDevice()) {
        setTimeout(() => {
          // appending token and new_format for windows event
          data = this.appendWindowsPrintPayload(data, 'cash_management');
          this.openReceiptWindow(data, timeout);
        }, delay);
      }
    } catch {}
  }

  isValidJson(string) {
    try {
      let parsed_json = JSON.parse(string);
    } catch (error) {
      return false;
    }
    return true;
  }

  sendFinalPrintMasterDocket(order_id) {
    let data = {
      order_id: order_id,
      type: 7,
      counter_id: '',
      itr: 1,
    };

    if (this.isReactDevice() && this.isPrinterEnabled()) {
      this.send_data_to_react(this.getDataWithDeviceIdIfMultiCashDrawerEnable(data));
    } else if (this.isPrinterEnabled()) {
      // appending token and new_format for windows event
      data = this.appendWindowsPrintPayload(data, 'non_cash_management');
      this.openReceiptWindow(data);
    }
  }

  sendTableServicePrintCommand(order_id) {
    let data = {
      order_id: order_id,
      type: 9,
      counter_id: '',
      itr: 1,
      new_format: 1,
    };

    if (this.isReactDevice() && this.isPrinterEnabled()) {
      this.send_data_to_react(data);
    } else if (this.isPrinterEnabled()) {
      // appending token and new_format for windows event
      data = this.appendWindowsPrintPayload(data, 'non_cash_management');
      this.openReceiptWindow(data);
    }
  }
  sendPrintWithItr(order_id, items, counterid, iteration) {
    let data = {
      order_id: order_id,
      type: 0,
      counter_id: counterid,
      itr: parseInt(iteration),
    };

    if (this.isReactDevice() && this.isPrinterEnabled()) {
      this.send_data_to_react(data);
    } else if (this.isPrinterEnabled()) {
      // appending token and new_format for windows event
      data = this.appendWindowsPrintPayload(data, 'non_cash_management');
      this.openReceiptWindow(data);
    }
  }

  sendVoidCommand(order_id, item_id, order_item_id, quantity) {
    let data = {
      order_id: order_id,
      type: 3,
      oid: order_item_id,
      qty: quantity,
    };

    if (this.isReactDevice() && this.isPrintOnVoid()) {
      this.send_data_to_react(data);
    } else if (this.isPrintOnVoid()) {
      // appending token and new_format for windows event
      data = this.appendWindowsPrintPayload(data, 'non_cash_management');
      this.openReceiptWindow(data);
    }
  }

  sendEodPrintCommand(restaurant_id, type) {
    let data = {
      restaurant_id: restaurant_id,
      receipt_type: type,
    };

    if (this.isPrinterEnabled() && !this.isReactDevice()) {
      // appending token and new_format for windows event
      data = this.appendWindowsPrintPayload(data, 'cash_management');
      this.openReceiptWindow(data);
    }
  }

  sendCancelCommand(order_id, itr) {
    let data = {
      order_id: order_id,
      type: 5,
      counter_id: '',
      itr: itr,
    };

    if (this.isReactDevice() && this.isPrintOnCancel()) {
      this.send_data_to_react(data);
    } else if (this.isPrintOnCancel()) {
      // appending token and new_format for windows event
      data = this.appendWindowsPrintPayload(data, 'non_cash_management');
      this.openReceiptWindow(data);
    }
  }

  sendTransferTableComand(order_id) {
    let data = {
      order_id: order_id,
      type: 6,
    };
    if (this.isReactDevice()) {
      this.send_data_to_react(
        this.getDataWithDeviceIdIfMultiCashDrawerEnable(data)
      );
    } else {
      // appending token and new_format for windows event
      data = this.appendWindowsPrintPayload(data, 'non_cash_management');
      this.openReceiptWindow(data);
    }
  }

  // send action to open cash drawer and print receipt on cash select option
  send_dkick_code_to_react(dkick_code, rest_printer, order_id, type) {
    const data = {
      restaurant_id: localStorage.getItem('restaurant_id'),
      action: 'dkick',
      dkick_code: dkick_code,
      printerName: rest_printer,
    };
    if (dkick_code !== '' && dkick_code !== undefined && dkick_code !== null) {
      if (type !== CashierActionType.closeCashier) {
        this.send_data_to_react(data);
      }
    }
  }

  receiptOffline(data) {
    this.webSocket.offlineReceipt(data).subscribe(
      (res: any) => {
        this.sendReceiptData(res);
        this.trackReactNativePrintEvent(
          'socket-reactNative-print-trigger',
          data
        );
      },
      (err) => console.log(err)
    );
  }
  receiptOfflineCashDrawer(data) {
    this.webSocket.offlineReceiptCashDrawer(data).subscribe(
      (res: any) => {
        this.sendReceiptData(res);
        this.trackReactNativePrintEvent(
          'socket-reactNative-print-trigger',
          data
        );
      },
      (err) => console.log(err)
    );
  }

  sendReceiptData(res) {
    // this.webSocket.socket.send(
    //   JSON.stringify({ command: "print", payload: res.data })
    // );
    this.webSocket.sendMessage({ command: 'print', payload: res.data });
  }

  isSocketPrintEnabled() {
    const restSettings: any = JSON.parse(
      localStorage.getItem('restaurant_settings')
    );
    return ((restSettings.global || {}).socket_printing || 0) === 1;
  }

  // Sent event for print-trigger
  trackReactNativePrintEvent(eventName, data) {
    this._eventTracker.easyeat_track_event(eventName, {
      User_Email_ID: localStorage.getItem('email'),
      User_name: localStorage.getItem('user_name'),
      Restaurant_ID: localStorage.getItem('restaurant_id'),
      Restaurant_Name: localStorage.getItem('restaurant_nameid'),
      User_role: localStorage.getItem('ee_user_type'),
      ORDER_ID: data.order_id,
      REST: localStorage.getItem('restaurant_id'),
      TIME: new Date(),
      DATA: data,
    });
  }

  // open new window for print
  openReceiptWindow(data, timeout = null) {
    // const rest_id = localStorage.getItem("restaurant_id");
    const isSocketPrintEnabled = this.isSocketPrintEnabled();
    if (
      isSocketPrintEnabled &&
      data.new_format === 1 &&
      this.webSocket.socketStatus
    ) {
      if(data?.type === 11){
        this.printDynamicQr(data);
      }else if (data?.order_id) {
        this.receiptOffline(data);
      }else if (data?.restaurant_id) {
        this.receiptOfflineCashDrawer(data);
      }
    } else {
      let x = JSON.stringify(data);
      if (timeout === null) {
        timeout = this.getReceiptWindowTime();
      }
      let finalData = this.getReceiptProtocolName() + ':' + encodeURI(x);
      let win = window.open(
        finalData,
        'receiptwindow',
        'width=1,height=1,left=5,top=3,location=0'
      );
      if (!win) {
        this.messageService.showError(
          'Print window is being blocked! Please allow it from setting'
        );
      }
      setTimeout(function () {
        try {
          win.close();
        } catch (error) {}
      }, timeout);

      this.trackReactNativePrintEvent('reactNative-print-trigger', data);
    }
  }

  printDynamicQr(data){
  this.webSocket.offlineDynamicQr(data).subscribe(
    (res: any) => {
      this.sendReceiptData(res);
      this.trackReactNativePrintEvent(
        'socket-reactNative-print-trigger',
        data
      );
    }),
    (err) => console.log(err)
  }

  // get device type -- web (0) or react native(1)
  isReactDevice() {
    if (localStorage.getItem('is_react') == '1') {
      return 1;
    } else {
      return 0;
    }
  }

  getReceiptProtocolName() {
    let receipt_keyname = 'ReceiptPrint';
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      receipt_keyname = restSettings['print']['receipt_keyname'];
      if (
        receipt_keyname === undefined ||
        receipt_keyname === '' ||
        receipt_keyname === null
      ) {
        receipt_keyname = 'ReceiptPrint';
      }
    } catch (error) {
      receipt_keyname = 'ReceiptPrint';
    }
    return receipt_keyname;
  }

  isPrinterEnabled() {
    let printer_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      printer_enabled = restSettings['print']['enabled'];
    } catch (error) {}
    return printer_enabled;
  }

  isLockEnabled() {
    let lock_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      lock_enabled = restSettings['global']['lock_screen'];
    } catch (error) {}
    return lock_enabled;
  }
  lockScreenTime() {
    let timeout = 20;
    let idle_time = 300;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      timeout = restSettings['global']['lock_screen_timeout'];
      idle_time = restSettings['global']['lock_screen_idle'];
    } catch (error) {
      timeout = 20;
      idle_time = 300;
    }
    if (!timeout) {
      timeout = 20;
    }
    if (!idle_time) {
      idle_time = 300;
    }
    return {
      idle: idle_time,
      timeout: timeout,
    };
  }

  isPOSEnabled() {
    let pos_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      pos_enabled = restSettings['global']['pos'] || this.isKiosk();
    } catch (error) {}
    return pos_enabled;
  }
  isKiosk() {
    let kiosk = 0;
    try {
      let restSettings = JSON.parse(
        this._localStorage.get('restaurant_settings')
      );
      kiosk = restSettings['global']['is_kiosk'];
    } catch (error) {}
    return kiosk;
  }
  isFcChildOutlet(){
    let fcChild = false;
    try {
      const foodcourtKey = this._localStorage.get('foodcourt');
      if (foodcourtKey) {
        fcChild = !!foodcourtKey;
      }
    } catch (error) {
      console.error(error);
    }
    return fcChild;
  }
  isKioskChild(): boolean {
    let kioskChild = false;
    try {
      let restSettings = JSON.parse(
        this._localStorage.get('restaurant_settings') || '{}'
      );
      kioskChild = !!restSettings?.global?.is_kiosk_child;
    } catch (error) {
      console.error(error);
    }
    return kioskChild;
  }
  isDisableFcAction() {
    let disable = 0;
    try {
      let restSettings = JSON.parse(
        this._localStorage.get('restaurant_settings')
      );
      disable = restSettings['global']['disable_foodcourt_operation'];
    } catch (error) {}
    return disable;
  }

  getKioskFcList() {
    let kioskFcList = [];
    try {
      kioskFcList = JSON.parse(this._localStorage.get('kiosk_fc_list'));
    } catch (error) {}
    return kioskFcList;
  }

  isVoidEnabled() {
    let void_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      void_enabled = restSettings['global']['void'];
    } catch (error) {}
    return void_enabled;
  }
  isVoidCompletedEnabled() {
    let void_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      void_enabled = restSettings['global']['void_item_after_completed'];
    } catch (error) {}
    return void_enabled;
  }

  isHideActionButton() {
    let hide_action_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      hide_action_enabled = restSettings['global']['hide_action_button'];
    } catch (error) {}
    return hide_action_enabled;
  }

  // hide accept order btn from app
  isHideActionButtonReact() {
    let hide_action_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      hide_action_enabled = restSettings['global']['hide_action_button_react'];
      if (!this.isReactDevice()) {
        hide_action_enabled = 0;
      }
    } catch (error) {}
    return hide_action_enabled;
  }

  getReceiptWindowTime() {
    let timeout = 3000;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      if (restSettings['print']['receipt_timeout'] !== undefined) {
        timeout = restSettings['print']['receipt_timeout'];
      }
    } catch (error) {
      timeout = 3000;
    }
    return timeout;
  }

  getCashDrawerWindowTime() {
    let timeout = 1000;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      if (restSettings['print']['cd_timeout'] !== undefined) {
        timeout = restSettings['print']['cd_timeout'];
      }
    } catch (error) {
      timeout = 1000;
    }
    return timeout;
  }

  // continous beep until restaurant accept the order, react
  beepTillActionEnabled() {
    let is_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      if (restSettings['sounds']['continous_beep_react'] !== undefined) {
        is_enabled = restSettings['sounds']['continous_beep_react'];
      }
    } catch (error) {
      is_enabled = 0;
    }

    return is_enabled;
  }

  getCashDrawerPrinterTimeDiff() {
    let timeout = 2000;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      if (restSettings['print']['receipt_cd_timediff'] !== undefined) {
        timeout = restSettings['print']['receipt_cd_timediff'];
      }
    } catch (error) {
      timeout = 2000;
    }
    return timeout;
  }

  isReceiptPrintOnSettlement() {
    let pre_settle = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      pre_settle = restSettings['print']['on_settle'];
    } catch (error) {}
    return pre_settle;
  }

  isPrintOnAccept() {
    let print_onaccept = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      print_onaccept = restSettings['print']['on_accept_enabled'];
    } catch (error) {}
    return print_onaccept;
  }

  isPrintOnVoid() {
    let void_print_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      void_print_enabled = restSettings['print']['void_enabled'];
    } catch (error) {}
    return void_print_enabled;
  }

  isNewMenuVariantEnabled() {
    let variation_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      if (restSettings['menu']['new_variation'])
        variation_enabled = restSettings['menu']['new_variation'];
    } catch (error) {}
    return variation_enabled;
  }

  isPrintOnCancel() {
    let cancel_print_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      cancel_print_enabled = restSettings['print']['on_decline'];
    } catch (error) {}
    return cancel_print_enabled;
  }

  isSplitBillEnabled() {
    let split_bill_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      split_bill_enabled = restSettings['global']['split_bill'];
    } catch (error) {}
    return split_bill_enabled;
  }
  isRemoveServiceEnabled() {
    let skip_service_chrg_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      skip_service_chrg_enabled = restSettings['global']['skip_service_chrg'];
    } catch (error) {}
    return skip_service_chrg_enabled;
  }
  isSkipPackageChargeEnabled() {
    let skip_pkg_charge = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      const value = restSettings['global']['skip_pkg_chrg'];
      if (value === 2 || value === 3) skip_pkg_charge = 1;
    } catch (error) {}
    return skip_pkg_charge;
  }
  isFpIntegrationEnabled() {
    let fp_integration = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      fp_integration = restSettings['global']['fp_integration'];
    } catch (error) {}
    return fp_integration;
  }
  // function returns autoaccept setting enabled for order & Schedule order

  isAutoAcceptOrderEnabled(type) {
    let key;
    if (type === 'order') {
      key = 'auto_accept';
    } else if (type === 'schOrder') {
      key = 'auto_accept_sch';
    }
    let autoAccept = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      const value = restSettings['global'][key];
      if (value) autoAccept = value;
    } catch (error) {}
    return autoAccept;
  }
  isItemDiscountEnabled() {
    let itemDiscount_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      itemDiscount_enabled = restSettings['global']['item_level_discount'];
    } catch (error) {}
    return itemDiscount_enabled;
  }

  isLoyaltyCashbackEnabled() {
    let loyalty_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      loyalty_enabled = restSettings['global']['loyalty_v2_visible_on_pos'];
    } catch (error) {}
    return loyalty_enabled;
  }

  isReactNativeRepeatNotificationEnabled(): boolean {
    return !!this.isReactDevice();
  }

  getPrintReponseFormat() {
    let defaultValue = 1;
    let newFormatValue;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      newFormatValue = restSettings['print']['response_format'];
    } catch (error) {}
    if (!(newFormatValue === 0 || newFormatValue === 1))
      newFormatValue = defaultValue;
    return newFormatValue;
  }

  getCashManagementOverrideFormat() {
    let defaultValue = 1;
    let newFormatValue;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      newFormatValue = restSettings['print']['cash_mgt_format_override'];
    } catch (error) {}
    if (newFormatValue === 0 || newFormatValue === 1) {
      newFormatValue = newFormatValue === 0 ? 1 : 0;
    } else newFormatValue = defaultValue;

    return newFormatValue;
  }

  appendWindowsPrintPayload(payload, type) {
    payload['new_format'] =
      type === 'non_cash_management'
        ? this.getPrintReponseFormat()
        : this.getCashManagementOverrideFormat();
    payload['token'] = localStorage.getItem('token') || null;
    return payload;
  }

  // function returns valid ordertypes array from bitwise operation

  getValidOrderTypes(bitwise: number) {
    const orderTypes = [];
    if ((bitwise & 1) === 1) orderTypes.push(0);
    if ((bitwise & 2) === 2) orderTypes.push(1);
    if ((bitwise & 4) === 4) orderTypes.push(2);
    return orderTypes;
  }
  getValidPlatformTypes(bitwise: number) {
    const platform = [];
    if ((bitwise & 1) === 1) platform.push('easyeat');
    if ((bitwise & 2) === 2) platform.push('foodpanda');
    if ((bitwise & 4) === 4) platform.push('grab');
    return platform;
  }

  get_itrs_for_order(order_items, kCounters) {
    let all_itrs_of_order = {};
    let itr = 0;
    const valid_status = ['1', '2', '3', '0'];
    const items = Array.isArray(order_items) ? order_items : [];
    const counters = Array.isArray(kCounters) ? kCounters : [];

    for (const item of items) {
      itr = item['itr'];

      if (valid_status.includes(item['item_status'].toString())) {
        if (!all_itrs_of_order.hasOwnProperty(itr)) {
          all_itrs_of_order[itr] = {};
        }

        let mapping_found = false;
        let counter_overridden = false;

        if (
          item['kitchen_counter_id'] !== undefined &&
          item['kitchen_counter_id'] !== null &&
          item['kitchen_counter_id'] !== ''
        ) {
          counter_overridden = true;
        }

        for (const counter of counters) {
          if (counter_overridden && counter.items.includes(item['item_id'])) {
            mapping_found = true;
            if (
              !all_itrs_of_order[itr].hasOwnProperty(counter.kitchen_counter_id)
            ) {
              all_itrs_of_order[itr][counter.kitchen_counter_id] = [];
            }
            all_itrs_of_order[itr][counter.kitchen_counter_id].push({
              itemname: item['item_name'],
              itemquantity: item['item_quantity'],
              itemcounter: counter.kitchen_counter_id,
              itemPrinter: counter.printer_name,
              itemVariations: item['variation_name'],
              itemAddons: item['addons_name'],
            });
          }
          if (
            !counter_overridden &&
            counter.subcategories.includes(item['subcategory_id'])
          ) {
            mapping_found = true;
            if (
              !all_itrs_of_order[itr].hasOwnProperty(counter.kitchen_counter_id)
            ) {
              all_itrs_of_order[itr][counter.kitchen_counter_id] = [];
            }
            all_itrs_of_order[itr][counter.kitchen_counter_id].push({
              itemname: item['item_name'],
              itemquantity: item['item_quantity'],
              itemcounter: counter.kitchen_counter_id,
              itemPrinter: counter.printer_name,
              itemVariations: item['variation_name'],
              itemAddons: item['addons_name'],
            });
          }
        }

        if (!mapping_found) {
          if (!all_itrs_of_order[itr].hasOwnProperty('default')) {
            all_itrs_of_order[itr]['default'] = [];
          }
          all_itrs_of_order[itr]['default'].push({
            itemname: item['item_name'],
            itemquantity: item['item_quantity'],
            itemcounter: 'default',
            itemPrinter: 'default',
            itemVariations: item['variation_name'],
            itemAddons: item['addons_name'],
          });
        }
      }
    }
    return all_itrs_of_order;
  }

  clear_cart() {
    const formData: any = new FormData();
    formData.append('token', localStorage.getItem('cart_token'));
    this.apiService.clearCart(formData).subscribe(
      (res: any) => {},
      (error) => {
        console.error('Error clearing cart:', error?.message);
      }
    );
  }

  restdiscount_enabled() {
    let discount_enabled = 0;
    let restSettings = JSON.parse(localStorage.getItem('restaurant_settings'));
    try {
      discount_enabled = restSettings['discount']['enabled'];
    } catch (error) {}
    return discount_enabled;
  }


  item_added_segment(src, item, qty) {
    this._eventTracker.easyeat_track_event('ITEM_ADDED_TO_CART', {
      'Order Source': src,
      'Order Type': parseInt(localStorage.getItem('pos_order_type')),
      'Order Scheduled': false,
      ORDER_ID: localStorage.getItem('pos_order_id'),
      ITEM_NAME: item.item_name,
      ITEM_CATEGORY: item.category_id,
      ITEM_PRICE: item.original_price,
      PREVIOUS_QUANTITY: item.quantity,
      UPDATED_QUANTITY: parseInt(item.quantity) + qty,
    });
  }

  send_data_to_react(data, type?) {
    let typePresets = {
      'cash-in': 1,
      'cash-out': 2,
      'drawer-kick': 4,
      'open-cashier': 8,
      'close-cashier': 16,
      'dynamic-qr': 11
    };
    try {
      data['authorizationToken'] = `Bearer ${localStorage.getItem('token')}`;
      let x = JSON.stringify(data);

      if (type) {
        const restSettings = JSON.parse(
          localStorage.getItem('restaurant_settings')
        );
        const action = (restSettings.print || {}).cash_drawer || 0;

        if(type === 'dynamic-qr'){
          send_data(x);
        }
        else if (typePresets[type] & action) {
          send_data(x);
        } else if (typePresets[type]) {
          if (type !== CashierActionType.closeCashier) {
            this.send_dkick_code_to_react(
              localStorage.getItem('dkick_code'),
              localStorage.getItem('restaurant_printer')
                ? localStorage.getItem('restaurant_printer')
                : 'Default Printer',
              null,
              type
            );
          }
        }
      } else send_data(x);

      this.trackReactNativePrintEvent('reactNative-print-trigger', data);
    } catch (error) {}
  }

  generateFileName(url) {
    return decodeURIComponent(url.split('/')[url.split('/').length - 1]);
  }

  returnUserType() {
    const x = localStorage.getItem('user_type');
    if (x == 'MM') return `Manager`;
    else if (x == 'SS') return `Server Staff`;
    else if (x == 'KS') return `Kitchen Staff`;
  }
  cashRegistryEnabled() {
    let cash_registry_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      cash_registry_enabled = restSettings['global']['cash_registry'];
    } catch (error) {}
    return cash_registry_enabled;
  }

  commissionEditEnabled() {
    let commision_edit_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      commision_edit_enabled = restSettings['global']['edit_commision'];
    } catch (error) {}
    return commision_edit_enabled;
  }
  finalBillPrintOnPOSDoneEnabled() {
    let post_settle = 0;
    try {
      const restSettings = JSON.parse(
        this._localStorage.get('restaurant_settings')
      );
      post_settle = (restSettings['print'] || {})['post_settle'];
    } catch (error) {}
    return post_settle;
  }
  finalBillPrintOnPOSEnabled() {
    let post_settle = 0;
    try {
      const restSettings = JSON.parse(
        this._localStorage.get('restaurant_settings')
      );
      post_settle = (restSettings['global'] || {})['is_pos_prepaid_enabled'];
    } catch (error) {}
    return post_settle;
  }
  lastActive() {
    let last_active_feature = 0;
    try {
      const restSettings = JSON.parse(
        this._localStorage.get('restaurant_settings')
      );
      last_active_feature = (restSettings['global'] || {})[
        'last_active_feature'
      ];
    } catch (error) {}
    return Number(last_active_feature);
  }
  litePricing() {
    let pricing = false;
    try {
      const restSettings = JSON.parse(
        this._localStorage.get('restaurant_settings')
      );
      pricing = [membership.LITE , membership.LITE_DEL].includes(restSettings?.global?.plan)
    } catch (error) {}
    return pricing;
  }
  getRestaurantPlan() {
    let plan = membership.LITE;
    try {
      const restSettings = this.getRestaurantSettings()
      plan = (restSettings['global'] || {})['plan']
    } catch (error) {}
    return plan;
  }
  litePricingDelivery() {
    let pricing = false;
    try {
      const restSettings = JSON.parse(
        this._localStorage.get('restaurant_settings')
      );
      pricing = (restSettings['global'] || {})['plan'] === membership.LITE_DEL;
    } catch (error) {}
    return pricing;
  }
  litePricingHq(type?: boolean): boolean {
    try {
      const hqSettings = JSON.parse(this._localStorage.get('ee_outlets'));
      const disallowed = type
        ? [membership.LITE]
        : [membership.PRO, membership.PRO_SUBS];
  
        const isAllowedPlan = (outlet: any) => {
          const plan = outlet?.settings?.global?.plan;
          return !disallowed.includes(plan);
        };
        return hqSettings.every(isAllowedPlan);        
    } catch (error) {
      return false;
    }
  }
  lastActiveInterval() {
    let last_active_call_interval = 0;
    try {
      const restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      const defaultInterval  = 300000; // 5 minutes (5 * 60 * 1000) in milliseconds
      last_active_call_interval = (restSettings['global'] || {})[
        'last_active_call_interval'
      ] || defaultInterval;
    } catch (error) {}
    return Number(last_active_call_interval);
  }
  isValidItemCode(itemcode) {
    const invalid_value = [null, '', undefined];
    if (invalid_value.includes(itemcode)) return false;
    else return true;
  }

  /*function returns round number with custom power and decimal parameters*/
  returnRoundNumber(number, power, decimal_place) {
    let multiplier = Math.pow(10, power);
    return Number(
      (Math.round(number * multiplier) / multiplier).toFixed(decimal_place)
    );
  }
  /*Function returns current time into number of minutes elapsed*/
  convertUTCToMinutes(time) {
    let hh = time.getHours();
    let mm = time.getMinutes();
    let minutes = hh * 60 + mm;
    return minutes;
  }
  /*Function returns date object from numbers if minutes elapsed*/
  startPolling(api, interval, params, isInitialTrigger?: boolean) {
    if (isInitialTrigger) {
      // Call the API manually for the first time
      if(this.lastActiveIntervalInterval) {
        // Clear existing interval
        clearInterval(this.lastActiveIntervalInterval);
      }
      this.callLastActiveApi(api, params);
    }
     // Start polling at regular intervals
    this.lastActiveIntervalInterval = setInterval(() => {
      this.callLastActiveApi(api, params);
    }, interval);
  }

  callLastActiveApi(api, params) {
    if (this._localStorage.get('token')) {
      this.apiService[api](params).subscribe(
        (res) => {
          if ((res || {}).statusCode === 200) {
            return (res || {}).data;
          }
        },
        (error) => {
          return error;
        }
      ); 
    }
  }
  startDataPolling(
    api: string,
    interval: number,
    params: any
  ): Observable<any> {
    const dataSubject = new Subject<any>();

    // Function to fetch data
    const fetchData = () => {
      if (this._localStorage.get('token')) {
        this.apiService[api](params).subscribe(
          (res) => {
            if ((res || {}).statusCode === 200) {
              dataSubject.next((res || {}).data);
            }
          },
          (error) => {
            dataSubject.error(error);
          }
        );
      }
    };

    // Fetch data immediately
    fetchData();

    // Start interval-based polling after the initial fetch
    this.interval = setInterval(fetchData, interval);

    return dataSubject;
  }

  stopPolling() {
    clearInterval(this.interval);
  }

  /*Convert quicknotes array of object to array of names*/
  returnQuickNotesNameArr(quick_notes) {
    let x = [];
    try {
      x = quick_notes.map((x) => x.note);
    } catch (error) {}
    return x;
  }
  /*function Compare between two array and return difference */
  array_diff(a1, a2) {
    var a = [],
      diff = [];

    for (var i = 0; i < a1.length; i++) {
      a[a1[i]] = true;
    }

    for (var i = 0; i < a2.length; i++) {
      if (a[a2[i]]) {
        delete a[a2[i]];
      } else {
        a[a2[i]] = true;
      }
    }

    for (var k in a) {
      diff.push(k);
    }

    return diff;
  }

  copyCode(code) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = code;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  isIdEnvironment() {
    return this.languageService.getCountry() === country.id.country;
  }
  
  isMyEnvironment() {
    return this.languageService.getCountry() === country.ai.country;
  }

  isDeliveryFeatureEnabled() {
    return this.isMyEnvironment() || (this.isIdEnvironment() && this.getRestaurantSettings()?.global?.deliveryOrder?.toString() === '1');
  }

  getRestaurantSettings() {
    if (this.router.url.includes('hq')) {
      return {};
    } else {
      const rest_settings = this._localStorage.get('restaurant_settings');
      if (rest_settings) {
        return JSON.parse(rest_settings || '{}');
      } else {
        return {};
      }
    }
  }

  getHqSettings() {
      const hq_settings = this._localStorage.get('hq_settings');
      if (hq_settings) {
        return JSON.parse(hq_settings);
      } else {
        return {};
      }
  }

  // Method for sending data to react native devices
  sendDatatoReact(payload) {
    const data = JSON.stringify(payload);
    send_data(data);
  }

  isRealmEnabled() {
    if (this.router.url.includes('hq')) {
      return 0;
    } else {
      return this._localStorage.get('isRealmEnabled') === '1';
    }
  }

  masterDocketEnabled() {
    let restSettings = JSON.parse(localStorage.getItem('restaurant_settings'));

    return !!restSettings['print']['master_docket'];
  }

  recipeEnabled() {
    const rest_settings = this._localStorage.get('restaurant_settings');
    const allOutlets = JSON.parse(this._localStorage.get('ee_outlets'));
    if (this._hqService.isHqUser()) {
      const rest_id = this._localStorage.get('restaurant_id');
      return allOutlets.filter((o) => o.id == rest_id).length
        ? allOutlets.filter((o) => o.id == rest_id)[0].settings['global'][
            'is_recipe_enabled'
          ]
        : 0;
    } else {
      if (rest_settings && rest_settings !== 'undefined') {
        return JSON.parse(rest_settings)['global']['is_recipe_enabled'];
      }
    }
  }

  isRecipeEnabled() {
    return this.recipeEnabled();
  }

  getShowReferralProgram() {
    return !!((JSON.parse(localStorage.getItem('hq_settings')) || {})[
      'referral'
    ] || {})['enabled'];
  }

  getUserEmail() {
    return this._localStorage.get('email') || 'N/A';
  }

  getUserName() {
    return this._localStorage.get('user_name') || 'N/A';
  }

  getHqName() {
    return this._localStorage.get('restaurant_name') || 'N/A';
  }

  getUserHqName() {
    return this._localStorage.get('ee_mall_name') || 'NA';
  }

  getHqId() {
    return this._localStorage.get('hq_id') || 'N/A';
  }

  getUserRoles() {
    return this._localStorage.get('ee_user_type') || 'N/A';
  }
  addLog(
    event: string,
    res: any,
    currentUrl: string,
    apiUrl: string,
    status: string,
    error_msg: string,
    component_name: string,
    function_name: string,
    tags: string[]
  ) {
    // Event -> What was the event e.g. menu_creation_failed, etc
    // Response Data -> The response from the API
    // Response Error -> The error from the API
    // URL -> Current URL
    // API URL -> API URL which has been called
    // Status -> Success/Failed
    // Error Message -> Any Error Message you want to log for your reference
    // Component -> Component Name from where the Log function is being invoked
    // Function -> Function Name from where the Log function is being invoked
    // Tags -> Module Name like: CMM, Inventory, etc.
    const logObject = {
      App: 'Partner-App',
      Country: this.languageService.getCountry(),
      is_log: true,
      Event: event,
      data: {
        response_data: res,
        response_error: res,
        url: currentUrl,
        apiURL: apiUrl,
        status: status.toLowerCase(),
        User_id: this._localStorage.get('user_id') || '',
        Restaurant_id: this._localStorage.get('restaurant_id') || '',
        HQ_ID: this._localStorage.get('hq_id') || '',
        Error_message: error_msg,
        component: component_name,
        function: function_name,
        tag: tags,
      },
    };
    console.log(logObject);
  }

  handleImageError(event: Event, fallbackImage: string) {
    (event.target as HTMLImageElement).src = fallbackImage;
  }

  getOnlinePaymentParams(params: OnlinePaymentParamsInterface) {
    const {
      paymentMethod,
      orderId,
      isFcUnpaidOrder = false,
      childOrderIds = [],
      mergedOrderIds = [],
      fcOrderIds = [],
    } = params;

    const paymentPayload = {
      [PaymentMethod.doku_qris]: {
        [isFcUnpaidOrder ? 'fc_order_id' : 'order_id']: orderId,
        merged_order_ids: mergedOrderIds,
        child_order_ids: childOrderIds,
        restaurant_id: this._localStorage.get('restaurant_id'),
        country_code: country.id.country,
        payment_process: PAYMENT_PROCESS.CHECKOUT,
        payment_channel: PAYMENT_CHANNEL_ID.QRIS_CHANNEL_ID,
        payment_gateway: PAYMENT_GATEWAY.DOKU_GATEWAY,
        origin: 'pos',
        redirect_url: window.location.href,
        fc_order_ids: fcOrderIds,
      },
      [PaymentMethod.duitnow]: {
        [isFcUnpaidOrder ? 'fc_order_id' : 'order_id']: orderId,
        merged_order_ids: mergedOrderIds,
        child_order_ids: childOrderIds,
        country_code: country.ai.country,
        redeem_amount: 0,
        payment_channel: PAYMENT_CHANNEL_ID.DUITNOW_CHANNEL_ID,
        payment_gateway: PAYMENT_GATEWAY.RAZERPAY_GATEWAY,
        origin: 'pos',
        restaurant_id:this._localStorage.get('restaurant_id'),
        fc_order_ids: fcOrderIds,
      },
      [PaymentMethod.PINE_LABS]: {
        [isFcUnpaidOrder ? 'fc_order_id' : 'order_id']: orderId,
        merged_order_ids: mergedOrderIds,
        child_order_ids: childOrderIds,
        restaurant_id: this._localStorage.get('restaurant_id'),
        redeem_amount: PineLabsConsts.REDEEM_AMOUNT,
        country_code: country.ai.country,
        payment_channel: PineLabDefaultChannel.PAYMENT_CHANNEL,
        payment_gateway: PineLabsEnum.PAYMENT_GATEWAY,
        origin: PineLabsEnum.PAYMENT_ORIGIN,
        payment_process: PineLabsEnum.PAYMENT_PROCESS,
        fc_order_ids: fcOrderIds,
      },
    };
    return paymentPayload[paymentMethod];
  }

  getPineLabCollected(plObj) {
    return (
      (plObj.pine_labs_debit_collected || 0) +
      (plObj.pine_labs_credit_collected || 0) +
      (plObj.pine_labs_wallet_collected || 0)
    );
  }

  getPineLabCharged(plObj) {
    return (
      (plObj.pine_labs_debit_charge_amt || 0) +
      (plObj.pine_labs_credit_charge_amt || 0) +
      (plObj.pine_labs_wallet_charge_amt || 0)
    );
  }

  getDeviceUID() {
    // this will return unique device unique id, send by react native
    return this._localStorage.get('deviceId') || '';
  }

  isMultiCashDrawerEnabled(): boolean {
    try {
      const restSettings = JSON.parse(
        this._localStorage.get('restaurant_settings') || '{}'
      );
      const isMultiCashDrawerSettingEnable =
        ((restSettings || {}).global || {}).multiple_cashier || 0;
      return !!isMultiCashDrawerSettingEnable;
    } catch (error) {
      return false;
    }
  }

  isMultiDevicePrintingEnabled(): boolean {
    try {
      const restSettings = JSON.parse(
        this._localStorage.get('restaurant_settings') || '{}'
      );
      const isMultiDevicePrintSettingEnabled =
        restSettings?.global?.multi_device_print ?? 0;
      return !!isMultiDevicePrintSettingEnabled;
    } catch (error) {
      return false;
    }
  }

  getPrinterIp(resData) {
    if (this.isMultiCashDrawerEnabled()) {
      return this.getReceiptPrinterIp(resData);
    } else {
      return (resData || {}).printer;
    }
  }

  getReceiptPrinterIp(restaurantSettings) {
    const printerObjMappedToDevice = (
      (restaurantSettings || {}).receipt_printers || []
    ).find(
      (printer) =>
        (printer || {}).status === 1 &&
        ((printer || {}).device_ids || []).includes(this.getDeviceUID())
    );

    if (printerObjMappedToDevice) {
      return (printerObjMappedToDevice || {}).printer_ip || '';
    } else {
      console.log('Error No Printer Ip Mapped to this device');
    }
  }

  getDataWithDeviceIdIfMultiCashDrawerEnable(data) {
    const deviceId = this.getDeviceUID();
    if ((this.isMultiCashDrawerEnabled() || this.isMultiDevicePrintingEnabled()) && deviceId) {
      return { ...data, device_id: deviceId };
    } else {
      return data;
    }
  }

  getAnalyticsData() {
    const analyticsData = this._localStorage.get('analyticsData');
    if (analyticsData) {
      return JSON.parse(analyticsData);
    } else {
      return [];
    }
  }

  getIsKioskHq() {
    return !!((JSON.parse(localStorage.getItem('hq_settings')) || {})[
      'global'
    ] || {})['is_kiosk_hq'];
  }

  getIsFoodcourtHq() {
    return !!((JSON.parse(localStorage.getItem('hq_settings')) || {})[
      'global'
    ] || {})['is_fc_hq'];
  }

  getIsClientCouponHq() {
    return !!((JSON.parse(localStorage.getItem('hq_settings')) || {})[
      'global'
    ] || {})['is_client_coupon_hq'];
  }

  getIsClientCouponRest() {
    return !!((JSON.parse(localStorage.getItem('restaurant_settings')) || {})[
      'global'
    ] || {})['is_client_coupon_rest'];
  }

  showPromotionsOnPos() {
    const restSettings = this.getRestaurantSettings();
    const showPromotionsOnPos = restSettings?.global?.promotions_on_pos;
    if (showPromotionsOnPos !== null && showPromotionsOnPos !== undefined) {
      return showPromotionsOnPos;
    }
    return true;
  }

  getGlobalHQSettings() {
    return (
      (JSON.parse(this._localStorage.get('hq_settings')) || {}).global || {}
    );
  }


  showScanQrAd() {
    const rest_settings = JSON.parse(
      this._localStorage.get('restaurant_settings')
    );
    const showScanQrAd = ((rest_settings || {})['global'] || {})[
      'show_scan_qr_ad'
    ];
    if (showScanQrAd !== null && showScanQrAd !== undefined) {
      return showScanQrAd;
    }
    return false;
  }
  payAtKiosk() {
    const rest_settings = JSON.parse(
      this._localStorage.get('restaurant_settings')
    );
    const payAtKiosk = ((rest_settings || {})['global'] || {})['pay_at_kiosk'];
    if (payAtKiosk !== null && payAtKiosk !== undefined) {
      return payAtKiosk;
    }
    return false;
  }

  isFcChildCanSettle(): boolean {
    try {
      const restSettings = JSON.parse(
        this._localStorage.get('restaurant_settings') || '{}'
      );
      const canSettle = restSettings?.global?.is_fc_child_can_settle;
      return canSettle === 1 || canSettle === '1';
    } catch (error) {
      return false;
    }
  }
  getPrintFromDevice() {
    const pusherAutoPrint = JSON.parse(
      this._localStorage.get('pusher_auto_print')
    );
    if (pusherAutoPrint !== null && pusherAutoPrint !== undefined) {
      return pusherAutoPrint;
    }
    return true;
  }
  isPineLabEnabledForAnyRest() {
    let isPineEnabledForAnyRest = false;
    const allOutletsList =
      JSON.parse(this._localStorage.get('ee_outlets') || '[]') || [];
    if (Array.isArray(allOutletsList)) {
      for (let outLet of allOutletsList) {
        if ((((outLet || {}).settings || {}).global || {}).is_pine_lab_on) {
          isPineEnabledForAnyRest = true;
          break;
        }
      }
    }
    return isPineEnabledForAnyRest;
  }
  voucherEnabled() {
    const restSettings = JSON.parse(
      this._localStorage.get('restaurant_settings')
    );
    const voucherEnabled = ((restSettings || {})['global'] || {})['tp_voucher'];
    if (voucherEnabled !== null && voucherEnabled !== undefined) {
      return voucherEnabled;
    }
    return false;
  }

  isEEFreeDigitalMenuLeads() {
    let isActive = false;
    if (this.router.url.includes('hq')) {
      return isActive
    } else {
      const restSettings = this.getRestaurantSettings();
      isActive =
      ((restSettings || {})['global'] || {})['plan'] ===
      membership.EE_FREE_DIGITAL_MENU_LEADS;
    }
    return isActive;
  }
  
  showSpecialFieldInUserForm() {
    const rest_settings = this.getRestaurantSettings()
    const userSpecialCategory = ((rest_settings || {})['global'] || {})[
      'usr_spec_cat'
    ];
    if (userSpecialCategory !== null && userSpecialCategory !== undefined && this.isMyEnvironment()) {
      return !!userSpecialCategory;
    }
    return false;
  }

  getPrintDelay(){
    const restSettings = this.getRestaurantSettings()
    const printDelay = ((restSettings || {})['print'] || {})[
      'print_delay'
    ];
    if (printDelay !== null && printDelay !== undefined) {
      return printDelay;
    }
    return 3000;
  }
  
  isBoostPartnership(): boolean {
    const restSettings = this.getRestaurantSettings() || {};
    const isBoost = (restSettings.global || {}).partnership == 'boost';
    return isBoost;
  }

  // Enabling this setting will bypass the order type selection modal.
  skipOrderTypeModal(): boolean {
    const restSettings = this.getRestaurantSettings() || {};
    const isSkipOrderType = !!(
      (restSettings.global || {}).order_type_pre_select_enable || 0
    );
    return isSkipOrderType;
  }

  setDefaultDataForSkipOrderType() {
    this._localStorage.set('pos_order_type', 0);
    this._localStorage.set('pos_platform', 'easyeat');
    this._localStorage.set('pos_table_no', 'dl');
    this._localStorage.set('pos_table_id', 'dl');
    this._localStorage.set('pos_order_id', '');

    this.clear_cart();
  }

  showDynamicQr():boolean{
    const restaurantSetting =  this.getRestaurantSettings();   
    return !!(restaurantSetting?.global?.qr_ordering_plan);
  }

  getDynamicQrValidityTime(){
    const restaurantSetting =  this.getRestaurantSettings();
   return restaurantSetting?.global?.qr_ordering_def_validity ?? 1800;
  }
  
  getDynamicQrTimeMeasure(){
    const restaurantSetting =  this.getRestaurantSettings();
   return restaurantSetting?.global?.qr_ordering_time_format ?? 'minutes';
  }

  isOfflineReactDevice():boolean{
    try{
      const isReactDevice = this._localStorage.get('is_react') === '1';
      const isRealmEnabled = !!JSON.parse(
        this._localStorage.get('isRealmEnabled') || '0'
      );
      return isRealmEnabled && isReactDevice;
    }catch(error){
      console.error(error);
      return false;
    }
  }

  showFoodCourtSettlment():boolean{
    try{
      const restSetting = JSON.parse(
        this._localStorage.get('restaurant_settings') || '{}'
      )?.global;
      const showSettleMentReport = !!(restSetting?.show_foodcourt_settlement_report ?? 0);
      return showSettleMentReport;
    }catch(err){
      console.error(err);
    }
    return false;
  }
  showHqFoodCourtSettlment():boolean{
    try{
      const hqSetting = JSON.parse(
        this._localStorage.get('hq_settings') || '{}'
      )?.global;
      const showHqSettleMentReport = !!(hqSetting?.show_hq_foodcourt_settlement_report ?? 0);
      return showHqSettleMentReport;
    }catch(err){
      console.error(err);
    }
    return false;
  }
  showCdsConfig():boolean{
    const restSettings = this.getRestaurantSettings();
    return restSettings?.global?.show_cds_config ?? false;
  }

  playCdsNotifcatoin():boolean{
    const restSettings = this.getRestaurantSettings();
    return restSettings?.global?.play_sound_on_cds ?? false;
  }
}
